import { configureStore } from "@reduxjs/toolkit";
import chatReducer from "../store/slice/ChatSlice";
import notificationReducer from "../store/slice/NotificationSlice";
import callReducer from "../store/slice/CallSlice";
import emailSlice from "../store/slice/EmailSlice";
import TaskAndTicket from "../store/slice/TaskAndTicket";

export const Store = configureStore({
  reducer: {
    chat: chatReducer,
    notification: notificationReducer,
    call: callReducer,
    email: emailSlice,
    taskAndTicket: TaskAndTicket,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export default Store;
